import { render, staticRenderFns } from "./TransactionTypesComponent.vue?vue&type=template&id=31b8a40a"
import script from "./TransactionTypesComponent.vue?vue&type=script&lang=js"
export * from "./TransactionTypesComponent.vue?vue&type=script&lang=js"
import style0 from "./TransactionTypesComponent.vue?vue&type=style&index=0&id=31b8a40a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports